// extracted by mini-css-extract-plugin
export default {"admissions-container":"Admissions_admissions-container__UvoIu"};